export default {
  "animatePath": "_animatePath_10hm7_1",
  "drawUndraw": "_drawUndraw_10hm7_1"
};import "ni:sha-256;OJVe2Wjm0UDg0j35rOJMRxp6AakJ2Kaj4mvSfGnLKyo";